//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    methods: {
        hide () {
            this.$emit('hide')
        }
    },
    props: {
        decoration_type: {
            type: String
        },
        usage: {
            type: String
        }
    }
}
